export const features = {
    "template": "template2",
    "companyName": "Union Mutual Companies (Prod)",
    "inowEndpoint": "https://express.unionmutual.com",
    "tokenIssuer": "https://umv-inow.okta.com/oauth2/default",
    "clientId": "0oa4fjspzjhzBRBdz697",
    "features": {
        "CustomContentPage1": false,
        "CustomContentPage2": false,
        "addRegistrationEmail": true,
        "agentEmail": true,
        "agentLink": true,
        "agentPanel": true,
        "blockAchNumberOps": false,
        "changeCoverage": true,
        "claimDetailsDocuments": true,
        "claimDetailsPayments": true,
        "claimDocumentUpload": true,
        "claimList": true,
        "claimStatus": false,
        "combinePolicies": true,
        "coverageDetails": true,
        "cpPortalLinking": false,
        "customPrivacyStatement": false,
        "customTOS": false,
        "deactivateUserOnly": true,
        "defaultLossDateTime": true,
        "desktopDeliveryPreferencesDefaultExpanded": true,
        "editPayPlan": false,
        "hasOpenBalance": true,
        "loginPanelExpirationDate": "2999-01-01",
        "mfaEnabled": true,
        "mobileDeliveryPreferencesDefaultExpanded": false,
        "needHelp": true,
        "notificationPreferences": false,
        "otherPaymentAmountAllowed": true,
        "paperlessChoiceUpdate": true,
        "passwordResetInfo": true,
        "payPlanTypesToFilter": [
            "Mortgagee",
            "Agent",
            "Statement"
        ],
        "pendingOrScheduledPaymentsList": true,
        "policyDetailsAddressTypeCd": [],
        "policyDetailsAddress": true,
        "policyDocumentUpload": true,
        "policyForms": false,
        "policyFormsDownload": false,
        "policyUserAttachmentsDisplay": true,
        "printButtonEnabled": false,
        "recentPaymentsList": true,
        "rememberMe": false,
        "reportClaim": true,
        "scheduledPayments": false,
        "showImageTag": true,
        "standardPhoneLength": true,
        "unauthenticatedPayments": true,
        "unauthenticatedReportClaim": true,
        "useInsuredAttachments": true,
        "verifyAddress": true,
        "viewChangeRequests": true
    },
    "keys": {
        "googleAnalytics": "",
        "googleAnalytics4": null,
        "googleAnalytics4GwDev": "G-R8Y22B4GYL",
        "googleAnalytics4GwProd": "G-C0D8F7WEDX",
        "googlePlacesApi": "AIzaSyByTfvRfjc9ahJ_4bux02P0olQHDysuVgo"
    },
    "salesPortalUrl": "https://umv-prod-cp.xi-1-us-west-2.guidewire.net",
    "cpProducts": [
        "Homeowners",
        "Personal Auto"
    ],
    "paymentApiUrl": "https://midas.api.omega2-andromeda.guidewire.net",
    "paymentSdkUrl": "https://js-sdk-prod.payments.guidewire.net/v1/gw-payments-sdk.js",
    "paymentTenantName": "tenant.umv",
    "paymentConfigIds": {
        "UMF": "12593401",
        "NEG": "12593401",
        "CMI": "12593401"
    },
    "paymentMethods": [
        "ACH",
        "CC",
        "UserSelect"
    ],
    "anonymousPaymentMethods": [
        "ACH",
        "CC",
        "UserSelect"
    ],
    "achEntryClassCode": "PPD",
    "processingFee": 4.95,
    "maxUploadFileSize": "500mb",
    "attachmentTemplatesLimit": "30",
    "policiesCountLimit": "50",
    "billingAccountsCountLimit": "50",
    "faviconFileExtension": "png",
    "policyCreatedSinceDt": 365,
    "policyStatusCd": "Active,Non-Renewed,Non-Renew Requested,Cancel Notice,Cancelled",
    "passwordConstraints": [
        {
            "constraint": "minLength",
            "value": 7,
            "message": "Use at least 7 characters"
        },
        {
            "constraint": "minNumber",
            "value": 1,
            "message": "Contain at least one number"
        },
        {
            "constraint": "minLowerCase",
            "value": 1,
            "message": "Contain at least one lower case letter"
        },
        {
            "constraint": "minUpperCase",
            "value": 1,
            "message": "Contain at least one upper case letter"
        }
    ],
    "userIdConstraints": [
        {
            "constraint": "minLength",
            "value": 3,
            "message": "Use at least 3 characters"
        }
    ],
    "downTime": {
        "beginTime": "2020-01-01T17:00-05:00",
        "endTime": "2020-12-31T17:00-05:00",
        "title": "<p>System Down for Maintenance<p>",
        "body": "<p>Union Express will be undergoing system maintenance and will be unavailable starting at 3:00 p.m. on Friday, Nov. 11, 2022 and will be back up on Monday, Nov. 14, 2022 at 8:00 a.m.</p>"
    },
    "signIn": {
        "title": "<p> <h4>Welcome to Union Mutual’s Customer Portal!</h4></p> <br/><br/>",
        "body": "<p>If you need assistance setting up your account, or paying your bill, please contact our Customer Support department at <br/>1-800-300-5261.</p> <br/><br/> <p> For more information, including billing options, please click <a href='https://www.unionmutual.com/resources/set-up-online-account' target='_blank'>here</a> for our FAQs.</p>"
    },
    "notificationSmsNumber": "123-456-7890",
    "billingStatusCd": "Normal, Cancel, Legal",
    "apiResponseSizeLimit": 100,
    "_meta": {
        "build": "4.0.0-41-7676780",
        "commit": "7676780f03b717f13fc31a4a25bbec99a2462d57",
        "company": "umv",
        "date": "2025-05-15T17:45:47+00:00",
        "source": "serviceportal-four-config",
        "version": "4.0.0",
        "imageTag": ""
    }
};